import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, ButtonGroup, Container, Grid, Stack, Typography, TextField, Paper } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import moment from "moment";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { useSelector } from "react-redux";

export default function MyInfo() {
  const { username, avatar } = useSelector((state) => state.userInfo.userInfo);
  const navigate = useNavigate();
  const params = useParams();
  const [tab, setTab] = useState(0);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(null);

  const [form, setForm] = useState({
    // nickname: "",
    password: "",
    passwordNew: "",
    passwordNew2: "",
    // mobile: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSubmit() {
    const { password, passwordNew, passwordNew2 } = form;
    if (passwordNew !== passwordNew2) return alert("两次密码不一致");
    if (password === passwordNew) return alert("新密码和旧密码一样");

    axios
      .post("/user/changePwd", {
        ...form,
      })
      .then((res) => {
        console.log(res.data);
        const { code, msg, data } = res.data;
        if (code === 1) {
          setForm({
            password: "",
            passwordNew: "",
            passwordNew2: "",
          });
          alert(msg, 'success');
        } else {
          alert(msg);
        }
        
      })
      .catch((err) => {
        console.log("update personal info err: ", err);
      });
  }

  return (
    <Page title="个人中心">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">个人中心</Typography>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <FormItem title="登录名">
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar alt={username} src={avatar} />
              <Typography variant="subtitle2" noWrap>
                {username}
              </Typography>
            </Stack>
          </FormItem>

          {/* <FormItem title="手机号">
            <TextField fullWidth placeholder="手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
          </FormItem> */}

          <FormItem title="原始密码">
            <TextField fullWidth type="password" placeholder="原始密码" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
          </FormItem>

          <FormItem title="新密码">
            <TextField fullWidth type="password" placeholder="新密码" autoComplete="off" id="passwordNew" value={form.passwordNew} size="small" onChange={(e) => handleIptChange("passwordNew", e.target.value)} />
          </FormItem>

          <FormItem title="确认密码">
            <TextField fullWidth type="password" placeholder="确认密码" autoComplete="off" id="passwordNew2" value={form.passwordNew2} size="small" onChange={(e) => handleIptChange("passwordNew2", e.target.value)} />
          </FormItem>

          <FormItem>
            <Button variant="contained" onClick={handleSubmit}>
              确认保存
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
